import { Serializable } from "@tendercuts/models";

export class PosUser implements Serializable<PosUser> {
  private message: string;
  public group_id: number;
  public max_rp: number;
  private today_order_count: number;

  public entity_id: number;
  public id: number;
  public email: string;
  public phone: string;
  public firstname: string;
  public lastname: string;
  public rewards: number;
  public storeCredit: number;
  public address: string;
  public preferredPayment: string = null;
  public rewardsEarningPercentage = 0;

  constructor() {}

  get entityId() {
    return this.entity_id;
  }

  set entityId(id) {
    this.entity_id = id;
  }

  get rewardMessage() {
    return this.message;
  }

  get maxRewardsElgible(): number {
    return this.max_rp ? +this.max_rp : 50;
  }

  /**
   * Elgible to place order today
   * Today order count must be less than 2
   * To control store agents placing orders in their own numbers
   * and abusing rp, store bouns etc we did this hack.
   */
  get elgibleToPlaceOrder() {
    return this.today_order_count ? this.today_order_count < 2 : true;
  }

  get isElite(): boolean {
    return this.group_id == 4;
  }

  get isSpecial(): boolean {
    return this.group_id == 0;
  }

  set cutomerAddress(address) {
    this.address = address;
  }

  deserialize(input) {
    if (input == undefined) {
      return this;
    }
    this.id = input.id;
    this.entity_id = input.entity_id;
    this.email = input.email;
    this.phone = input.phone;
    this.firstname = input.firstname;
    this.lastname = input.lastname;
    this.preferredPayment = input.preferredPayment;
    this.rewards = input.rewards;
    this.rewardsEarningPercentage = 0;
    this.message = input.message;
    this.group_id = input.group_id;
    this.address = input.address;
    this.max_rp = input.max_rp;
    this.today_order_count = input.today_order_count;

    return this;
  }

  fireBaseSerialize() {
    return {
      id: this.entity_id !== undefined ? this.entity_id : null,
      p: this.phone !== undefined ? this.phone : null,
      n: this.firstname,
    };
  }
}
